import * as echarts from 'echarts';

// 折线图绘制
export function initChartsZhe(e:any,color:any,datas:any){
    let dataList =[];
    let dataYear=[];
    for(var j=0;j<12;j++){
        for(var i=0;i<datas.length;i++){
            if(datas[i].code==j+1){
                dataList.push(datas[i].count)
                let year = datas[i].name+'月';
                dataYear.push(year)
            }
        }
    }
    let myChart = echarts.init(e);
    const option={
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: dataYear,
        },
        yAxis: {
            type: 'value',
            show:false,
        },
        series: [{
            data: dataList,
            type: 'line',
            areaStyle: {
                color:{
                    type: 'linear',
                    x:0,
                    y:1,
                    x2:0,
                    y2:0,
                    colorStops: [{
                        offset: 0, color: color[0] // 0% 处的颜色
                    }, {
                        offset: 1, color: color[1] // 100% 处的颜色
                    }],
                },
                opacity:0.3
            },
            label: {
                show: true,
                position: 'top',
                color:color[1],
            },
        }]
    }
    myChart.setOption(option);
    return myChart;
}
//柱状图绘制
export function initChartsZhu(e:any,color:any,datas:any){
    let dataList =[];
    let dataYear=[];
    for(var j=0;j<12;j++){
        for(var i=0;i<datas.length;i++){
            if(datas[i].code==j+1){
                dataList.push(datas[i].count)
                let year = datas[i].name+'月';
                dataYear.push(year)
            }
        }
    }
    let myChart = echarts.init(e);
    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: dataYear,
        },
        yAxis: {
            type: 'value',
            show:false
        },
        series: [{
            data: dataList,
            type: 'bar',
            barWidth:6,
            label: {
                show: true,
                position: 'top',
                color:'#fff',
                fontSize:9,
            },
            itemStyle:{
                borderRadius:[6,6,6,6],
                color:{
                    type: 'linear',
                    x:0,
                    y:1,
                    x2:0,
                    y2:0,
                    colorStops: [{
                        offset: 0, color: color[0] // 0% 处的颜色
                    },{
                        offset: 0.9, color: color[1] // 0% 处的颜色
                    }, {
                        offset: 1, color: color[2] // 100% 处的颜色
                    }],
                },
            }

        }],

    };
    myChart.setOption(option);
    return myChart;
}
//三角柱状图
export function initChartsSanZhu(e:any,datas:any){
    let dataName:any =[];
    let dataList:any =[];
    datas.forEach((v:any)=>{
        dataList.push(v.count);
        dataName.push(v.name)
    })

    let myChart = echarts.init(e);
    const option = {
        tooltip: {
            show: true
        },
        grid: {
            bottom: '30%',
            top:'10%'
        },
        xAxis: {
            type: 'category',
            data:dataName,
            axisLine: {
                show:true,
                lineStyle: {
                    color: '#5BBAF9',
                }
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show:true,
                color: '#fff',
                fontSize: 10,
                rotate: -30, //-30度角倾斜显示
            }
        },
        yAxis: {
            splitLine:{ show:false} ,
            axisLabel:{
                show:false
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show:true,
                lineStyle: {
                    color: '#5BBAF9',
                }
            },
        },
        series: [{
            type: 'pictorialBar',
            symbol: 'path://d="M150 0 L75 200 L225 200 Z"',
            barCategoryGap: '-20%',
            label: {
                normal: {
                    show: true,
                    position: 'top',
                    color: '#ffffff',
                }
            },
            itemStyle: {
                color: function(params:any) {
                    return params.dataIndex % 2 ? darkBlue : lightBlue;
                }
            },
            data:dataList,
        }],
    };
    // 颜色
    var lightBlue = {
        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
        colorStops: [{
            offset: 0,
            color: '#1EAEE4' // 0% 处的颜色
        }, {
            offset: 1,
            color: 'rgba(14, 66, 97, 0.78)' // 100% 处的颜色
        }],
        globalCoord: false // 缺省为 false
    }
    var darkBlue = {
        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
        colorStops: [{
            offset: 0,
            color: 'rgba(40, 112, 231, 1)' // 0% 处的颜色
        }, {
            offset: 1,
            color: 'rgba(24, 52, 125, 0.76)' // 100% 处的颜色
        }],
        globalCoord: false // 缺省为 false
    };
    myChart.setOption(option);
    return myChart;
}
//饼状图
export function initChartsCircular(e:any,datas:any){
    let Data:any=[];
    datas.forEach((v:any)=>{
        let list = {name:v.name,value:v.count}
        Data.push(list)
    })
    console.log('initChartsCircular',Data)
    let myChart = echarts.init(e);
    const option = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            x: 'right',
            y:'bottom',
            textStyle:{
                color:'#01EEDE',
            },
            itemWidth:15,
            itemHeight:15,
            borderRadius:0
        },
        series: [
            {
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                minAngle: 10,
                emphasis: {
                    label: {
                        show: true,
                        fontSize: '20',
                        fontWeight: 'bold',
                        color:'#fff'
                    }
                },
                data: Data,
                label:{
                    color:'#01EEDE'
                }
            }
        ]
    };
    myChart.setOption(option);
    return myChart;
}
